var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#paint0_linear_2556_100900)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.996 360.428H112.539L192.634 275.264C198.312 269.181 203.787 272.729 205.814 275.264L236.737 303.652C253.77 315.007 270.87 308.384 277.292 303.652L307.707 275.264C312.574 270.397 317.846 273.574 319.874 275.771L401.996 360.428Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398.955 153.093H112.539L237.244 286.416C254.682 299.799 270.87 291.992 276.785 286.416L398.955 153.093Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M413.15 345.727V167.287L331.027 249.917C324.133 256 328.155 263.604 331.027 266.646L413.15 345.727Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.127 345.727V167.287L183.25 249.917C190.144 256 186.123 263.604 183.25 266.646L101.127 345.727Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2556_100900",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A75E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D0F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e855a45595991cf5f13fa3a33a25e4f5.svg";
export { ForwardRef as ReactComponent };